<template>
	<div class="experience-timeslot-weekday">
		<div class="week-row">
			<div class="weekday">
				{{ getWeekdayString(weekday) }}
			</div>
			<div class="timeslots">
				<div class="timeslots-wrapper">
					<div class="timeslot" @click="clickTimeslot(timeslot)" v-for="timeslot in timeslots">
						<div class="title">{{ timeslot.name }}</div>
						<div class="row centered space-between">
							<div class="value">{{ timeslot.start + " : " + timeslot.end }}</div>
							<div class="edit-icon" v-html="svgStore.get('iconEdit')"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="actions">
				<div class="action" v-html="svgStore.get('iconCopy')" @click="$emit('copy')" v-if="!noCopy"></div>
				<div class="action" v-html="svgStore.get('iconPlus')" @click="startAddNewSlot"></div>
			</div>
		</div>
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="timeslotEdit !== null" @toggling-popup="toggleBottomSheetTimeslotEdit">
			<div class="info-container" v-if="timeslotEdit !== null">
				<ExperienceTimeslotEdit ref="timeslot-edit" :timeslots="timeslots" :timeslot="timeslotEdit" @close="timeslotEdit = null" @delete="removeTimeslot" @add="addTimeslot" @edit="$emit('edit')" />
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import ExperienceTimeslotEdit from "@/console-new/components/plugins/reservations/ExperienceTimeslotEdit.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useExperiencesStore} from "@/console-new/stores";

export default {
	components: {AppBottomSheet, ModalHeader, ExperienceTimeslotEdit},
	setup() {
		const experiencesStore = useExperiencesStore();
		const languageStore = useLanguageStore();
		const svgStore = useSvgStore();
		return {getString: languageStore.getString, svgStore, experiencesStore};
	},
	name: "ExperienceTimeslotWeekday",
	emits: ['copy', 'delete', 'add', 'edit'],
	mixins: [WindowWidth],
	props: {
		weekday: Number,
		noCopy: {
			type: Boolean,
			default: false,
		},
		timeslots: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			timeslotEdit: null,
		}
	},
	computed: {
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
	},
	methods: {
		startAddNewSlot() {

			this.timeslotEdit = {
				experience_timeslot_id: "new" + Math.random(),
				name: this.timeslotName,
				price: this.timeslotPrice,
				start: this.timeslotStart,
				end: this.timeslotEnd,
				weekday: this.weekday,
				time: this.timeslotTime,
				intervals: this.timeslotIntervals,
				dontRequestCard: this.timeslotDontRequestCard,
			};

		},
		getWeekdayString(weekDay) {
			if(weekDay === 0) {
				return this.getString('monday');
			} else if(weekDay === 1) {
				return this.getString('tuesday');
			} else if(weekDay === 2) {
				return this.getString('wednesday');
			} else if(weekDay === 3) {
				return this.getString('thursday');
			} else if(weekDay === 4) {
				return this.getString('friday');
			} else if(weekDay === 5) {
				return this.getString('saturday');
			} else if(weekDay === 6) {
				return this.getString('sunday');
			}
		},
		toggleBottomSheetTimeslotEdit(open) {
			if(!open) {
				this.timeslotEdit = null;
			}
		},
		clickTimeslot(timeslot) {
			this.timeslotEdit = timeslot;
		},
		removeTimeslot() {
			this.$emit('delete', this.timeslotEdit.experience_timeslot_id);
			this.timeslotEdit = null;
		},
		addTimeslot() {

			let element = this.$refs["timeslot-edit"];

			let timeslot = {
				experience_timeslot_id: "new" + Math.random(),
				name: element.timeslotName,
				price: element.timeslotPrice,
				start: element.timeslotStart,
				end: element.timeslotEnd,
				weekday: this.weekday,
				time: element.timeslotTime,
				intervals: element.timeslotIntervals,
				dontRequestCard: element.timeslotDontRequestCard,
			};
			this.$emit('add', timeslot);
			this.timeslotEdit = null;

		},
	}
}
</script>

<style scoped lang="scss">
.experience-timeslot-weekday {
	display: flex;
	width: 100%;
	border-bottom: 1px solid $alpha;

	&:last-child {
		border-bottom: none;
	}

	.week-row {
		display: flex;
		padding: 4px 10px;
		width: 100%;

		.weekday {
			flex-shrink: 0;
			min-height: 65px;
			width: 110px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.timeslots {
			flex-grow: 1;
			display: flex;
			flex-wrap: wrap;
			flex-direction: row;
			align-items: center;
			overflow-x: auto;
			-ms-overflow-style: none;
			scrollbar-width: none;
			margin-right: 8px;

			.timeslots-wrapper {
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				align-items: center;
				padding: 8px;
				gap: 10px;
			}

			.timeslot {
				display: flex;
				flex-direction: column;
				padding: 4px 10px;
				width: 200px;
				background-color: $alpha_2;
				border-radius: 13px;
				cursor: pointer;

				.title {
					font-size: 15px;
					font-weight: 500;
				}

				.value {
					font-size: 14px;
					font-weight: 400;
				}

				.edit-icon {

					&:deep(svg) {
						width: 16px;
						height: 16px;
						fill: $primary;
					}
				}
			}
		}

		.actions {
			flex-shrink: 0;
			display: flex;
			gap: 8px;
			align-items: center;

			.action {
				border-radius: 13px;
				border: 1px solid $primary;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 9px;
				cursor: pointer;
				flex-shrink: 0;

				:deep(svg) {
					width: 16px;
					height: 16px;

					.fill {
						fill: $primary;
					}

					.stroke {
						stroke: $primary;
					}
				}

			}

		}
	}
}
</style>